import SplineAreaChartYahclickBandwidth from "@components/charts/Yahclick_charts/SplineAreaChartYahclickBandwidth";
import SplineAreaChartYahclickNGBandwidth from "@components/charts/Yahclick_charts/SplineAreaChartYahclickNGBandwidth";
import SplineAreaChartYahclickNGPing from "@components/charts/Yahclick_charts/SplineAreaChartYahclickNGPing";
import SplineAreaChartYahclickPing from "@components/charts/Yahclick_charts/SplineAreaChartYahclickPing";
import CustomAccordion from "@components/common/CustomAccordion";
import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

const YahsatServices = () => {
	const dispatch = useDispatch();
	const navigate = useNavigate();
	const token = useSelector((state) => state.auth.user.token);

	const [openAccordions, setOpenAccordions] = useState({
		yahclick: true,
		"yahclick-ng": true,
	});

	const loadingYahclick = useSelector((state) => state.modules.vessels.yahclick?.loading);

	const yahclickPing = useSelector(
		(state) => state.modules?.vessels?.yahclick?.pingHighLatencyYahclick || [],
	);

	const yahclickPingNG = useSelector(
		(state) => state.modules?.vessels?.yahclick?.pingHighLatencyYahclickNG || [],
	);

	const vesselStarlink = useSelector((state) => state.modules?.vessels?.vesselDetails || {});

	const yahclick_total_usage = useSelector(
		(state) => state.modules?.vessels?.vesselDetails?.yahclick_total_usage || null,
	);
	const yahclick_usage_unity = useSelector(
		(state) => state.modules?.vessels?.vesselDetails?.yahclick_usage_unity || "",
	);

	const yahclickBandwidth = useSelector(
		(state) => state.modules?.vessels?.yahclick?.yahclikBandwidth || [],
	);

	const yahclickBandwidthNG = useSelector(
		(state) => state.modules?.vessels?.yahclick?.yahclikBandwidthNG || [],
	);

	const yahclickDetails = useSelector((state) => state.modules.vessels?.vesselDetails?.yahclicks);

	const yahclick = yahclickDetails?.find((item) => item?.type == "0");

	const yahclickNG = yahclickDetails?.find((item) => item?.type == "1");

	const centreonStatus = yahclickPing?.[0]?.data?.modem_status || null;
	const centreonNGStatus = yahclickPingNG?.[0]?.data?.modem_status || null;
	const centreonOutput = yahclickPing?.[0]?.data?.output || null;
	const centreonNGOutput = yahclickPingNG?.[0]?.data?.output || null;

	const toggleAccordion = (id) => {
		setOpenAccordions((prevState) => ({
			...prevState,
			[id]: !prevState[id],
		}));
	};

	const currentLocalMonth = new Date().getMonth() + 1;

	// Get the previous month in local time
	const previousLocalMonth = currentLocalMonth === 1 ? 12 : currentLocalMonth - 1;
	const currentUtcMonth = new Date().getUTCMonth() + 1;
	const previousUtcMonth = currentUtcMonth === 1 ? 12 : currentUtcMonth - 1;

	const hasYahsatServices = vesselStarlink.yahclicks.length > 0;

	return (
		<>
			<div>
				{loadingYahclick ? (
					<div className="flex h-64 items-center justify-center">
						<div className="h-32 w-32 animate-spin rounded-full border-gray-700 border-t-2 border-b-2"></div>
					</div>
				) : hasYahsatServices ? (
					<div className="grid grid-cols-1 gap-2 md:grid-cols-1">
						{/* <TotalUsageSelectorYahclick
            // usageData={usageData}
            // currentUtcMonth={currentUtcMonth}
            // previousUtcMonth={previousUtcMonth}
            /> */}
						<div className={`} rounded border-dark-blue bg-dark-blue px-0 py-2`}>
							<div className="flex items-center justify-between p-3">
								<span className="font-bold text-lg text-white">This Month</span>
								<span className="p-1 font-semibold text-gray-300 text-xs sm:text-sm md:text-sm lg:text-md">
									Total Usage
								</span>

								<span className="rounded bg-green-cyan p-1 font-normal text-green-200 text-xs sm:text-sm md:text-sm lg:text-md">
									{/* {usageForMonth ? `${usageForMonth} GB` : "N/A"} */}
									{yahclick_total_usage} {""} <span>{yahclick_usage_unity}</span>
								</span>
							</div>
						</div>

						{yahclick && (
							<CustomAccordion
								title="YAHCLICK"
								id="yahsatCustomAccordion"
								isOpen={openAccordions[`yahclick`]}
								toggleAccordion={() => toggleAccordion(`yahclick`)}
								classCss="border-0 bg-[#1F2A37]"
							>
								<div className="grid grid-cols-1 gap-4 md:grid-cols-1">
									<div className="grid grid-cols-1 gap-6 px-10 py-4 text-start sm:grid-cols-2 md:grid-cols-4 md:gap-3 lg:grid-cols-4">
										{centreonStatus ? (
											<span
												className={`font-light text-sm ${centreonStatus === "UP" ? "text-green-400" : "text-red-500"} `}
											>
												<span>{centreonStatus} </span> - <span>{centreonOutput}</span>
											</span>
										) : (
											<span className="font-light text-blue-gray text-sm">
												Loading Yahclick status...
											</span>
										)}
										<span className="font-bold text-sm text-white">
											SAN NUMBER {""}{" "}
											<span className="font-light text-gray-300 text-sm">
												{" "}
												{yahclick?.san_number}
											</span>
										</span>
										<span className="font-bold text-sm text-white">
											Modem IP{""}{" "}
											<span className="font-light text-gray-300 text-sm">
												{" "}
												{yahclick?.modem_ip}
											</span>
										</span>
										<span className="font-bold text-sm text-white">
											FGT IP{""}{" "}
											<span className="font-light text-gray-300 text-sm">
												{" "}
												{yahclickNG?.fortiget_ip}
											</span>
										</span>
										<span className="font-light text-blue-gray text-sm">
											Last Check : <span>{yahclick?.last_check}</span>
										</span>
										<span className="font-bold text-sm text-white">
											SUBNET {""}{" "}
											<span className="font-light text-gray-300 text-sm"> {yahclick?.subnet}</span>
										</span>
										<span className="font-bold text-sm text-white">
											Static IP{""}{" "}
											<span className="font-light text-gray-300 text-sm">
												{" "}
												{yahclick?.static_ip}
											</span>
										</span>
									</div>
									<div
										className={`chart-column first-column flex rounded-lg border-[#272b49c5] border-t-2 border-solid`}
									>
										<div className="mt-4 mb-6 text-start font-bold text-white text-xs first:rounded-t-lg last:rounded-b-lg sm:text-sm md:text-base lg:text-lg">
											{`Ping High Latency Yahclick`}
										</div>
										{yahclickPing?.[0]?.data?.success === false &&
										yahclickPing?.[0]?.data?.metric === false ? (
											<div className="flex flex-col items-center justify-center py-10">
												<p className="text-blue-gray text-xs sm:text-sm">No data available</p>
											</div>
										) : yahclickPing?.[0]?.data?.success === false ? (
											<div className="flex h-64 items-center justify-center">
												<p className="text-blue-gray text-xs sm:text-sm">No data available</p>
											</div>
										) : yahclickPing?.[0]?.data?.metric?.length > 0 ? (
											<div className="grid grid-cols-1 gap-6">
												{yahclickPing[0].data.metric.map((ping, index) => (
													<div key={index} className="chart-row-100">
														<div className="chart-column w-100">
															<SplineAreaChartYahclickPing
																data={ping.data}
																times={ping.times}
																type={yahclickPing[0].type}
																id={`${yahclickPing[0].id}`}
																dispatch={dispatch}
																navigate={navigate}
															/>
														</div>
													</div>
												))}
											</div>
										) : (
											<div className="flex h-64 items-center justify-center">
												<p className="text-blue-gray text-xs sm:text-sm">Loading data...</p>
											</div>
										)}
									</div>
									<div className="chart-column first-column flex rounded-lg border-[#272b49c5] border-t-2 border-solid">
										<div className="mt-4 mb-6 text-start font-bold text-white text-xs first:rounded-t-lg last:rounded-b-lg sm:text-sm md:text-base lg:text-lg">
											{`Bandwidth Usage Yahclick`}
										</div>

										{yahclickBandwidth?.[0]?.data?.success === false &&
										yahclickBandwidth?.[0]?.data?.metric === false ? (
											<div className="flex flex-col items-center justify-center py-10">
												<p className="text-blue-gray text-xs sm:text-sm">No data available</p>
											</div>
										) : yahclickBandwidth?.[0]?.data?.success === false ? (
											<div className="flex h-64 items-center justify-center">
												<p className="text-blue-gray text-xs sm:text-sm">No data available</p>
											</div>
										) : yahclickBandwidth?.[0]?.data?.metric?.length > 0 ? (
											<div className="w-full">
												{yahclickBandwidth[0]?.data?.metric?.map((Bandwidth, index) => (
													<div key={index} className="chart-row-100">
														<div className="chart-column w-100">
															<SplineAreaChartYahclickBandwidth
																data={Bandwidth?.data}
																times={Bandwidth?.times}
																type={yahclickBandwidth[0]?.type}
																id={`${yahclickBandwidth[0]?.id}`}
																dispatch={dispatch}
																navigate={navigate}
															/>
														</div>
													</div>
												))}
											</div>
										) : (
											<div className="flex h-64 items-center justify-center">
												<p className="text-blue-gray text-xs sm:text-sm">Loading data...</p>
											</div>
										)}
									</div>
								</div>
							</CustomAccordion>
						)}

						{yahclickNG && (
							<CustomAccordion
								title="YAHCLICK NG"
								id="yahsatCustomAccordion"
								isOpen={openAccordions[`yahclick-ng`]}
								toggleAccordion={() => toggleAccordion(`yahclick-ng`)}
								classCss="border-0 bg-[#1F2A37]"
							>
								<div className="grid grid-cols-1 gap-4 md:grid-cols-1">
									<div className="grid grid-cols-1 gap-6 px-10 py-4 text-start sm:grid-cols-2 md:grid-cols-4 md:gap-3 lg:grid-cols-4">
										{centreonNGStatus ? (
											<span
												className={`font-light text-sm ${centreonNGStatus === "UP" ? "text-green-400" : "text-red-500"} `}
											>
												<span>{centreonNGStatus} </span> - <span>{centreonNGOutput}</span>
											</span>
										) : (
											<span className="font-light text-blue-gray text-sm">
												Loading Yahclick-NG status...
											</span>
										)}
										<span className="font-bold text-sm text-white">
											SAN NUMBER {""}{" "}
											<span className="font-light text-gray-300 text-sm">
												{" "}
												{yahclickNG?.san_number}
											</span>
										</span>
										<span className="font-bold text-sm text-white">
											Modem IP{""}{" "}
											<span className="font-light text-gray-300 text-sm">
												{" "}
												{yahclickNG?.modem_ip}
											</span>
										</span>
										<span className="font-bold text-sm text-white">
											FGT IP{""}{" "}
											<span className="font-light text-gray-300 text-sm">
												{" "}
												{yahclickNG?.fortiget_ip}
											</span>
										</span>
										<span className="font-light text-blue-gray text-sm">
											Last Check : <span>{yahclickNG?.last_check}</span>
										</span>
										<span className="font-bold text-sm text-white">
											SUBNET {""}{" "}
											<span className="font-light text-gray-300 text-sm">
												{" "}
												{yahclickNG?.subnet}
											</span>
										</span>
										<span className="font-bold text-sm text-white">
											Static IP{""}{" "}
											<span className="font-light text-gray-300 text-sm">
												{" "}
												{yahclickNG?.static_ip}
											</span>
										</span>
									</div>
									<div
										className={`chart-column first-column flex rounded-lg border-[#272b49c5] border-t-2 border-solid`}
									>
										<div className="mt-4 mb-6 text-start font-bold text-white text-xs first:rounded-t-lg last:rounded-b-lg sm:text-sm md:text-base lg:text-lg">
											{`Ping High Latency Yahclick NG`}
										</div>
										{yahclickPingNG?.[0]?.data?.success === false &&
										yahclickPingNG?.[0]?.data?.metric === false ? (
											// When data is not yet fetched
											<div className="flex flex-col items-center justify-center py-10">
												<p className="text-blue-gray text-xs sm:text-sm">No data available</p>
											</div>
										) : yahclickPingNG?.[0]?.data?.success === false ? (
											<div className="flex h-64 items-center justify-center">
												<p className="text-blue-gray text-xs sm:text-sm">No data available</p>
											</div>
										) : yahclickPingNG?.[0]?.data?.metric?.length > 0 ? (
											// When data is available
											<div className="grid grid-cols-1 gap-6">
												{yahclickPingNG[0].data.metric.map((ping, index) => (
													<div key={index} className="chart-row-100">
														<div className="chart-column w-100">
															<SplineAreaChartYahclickNGPing
																data={ping.data}
																times={ping.times}
																type={yahclickPingNG[0].type}
																id={`${yahclickPingNG[0].id}`}
																dispatch={dispatch}
																navigate={navigate}
															/>
														</div>
													</div>
												))}
											</div>
										) : (
											// When there's no metric data
											<div className="flex h-64 items-center justify-center">
												<p className="text-blue-gray text-xs sm:text-sm">Loading data...</p>
											</div>
										)}
									</div>
									<div className="chart-column first-column flex rounded-lg border-[#272b49c5] border-t-2 border-solid">
										<div className="mt-4 mb-6 text-start font-bold text-white text-xs first:rounded-t-lg last:rounded-b-lg sm:text-sm md:text-base lg:text-lg">
											{`Bandwidth Usage Yahclick NG`}
										</div>

										{yahclickBandwidthNG?.[0]?.data?.success === false &&
										yahclickBandwidthNG?.[0]?.data?.metric === false ? (
											<div className="flex flex-col items-center justify-center py-10">
												<p className="text-blue-gray text-xs sm:text-sm">No data available</p>
											</div>
										) : yahclickBandwidthNG?.[0]?.data?.success === false ? (
											<div className="flex h-64 items-center justify-center">
												<p className="text-blue-gray text-xs sm:text-sm">No data available</p>
											</div>
										) : yahclickBandwidthNG?.[0]?.data?.metric?.length > 0 ? (
											<div className="w-full">
												{yahclickBandwidthNG[0]?.data?.metric?.map((Bandwidth, index) => (
													<div key={index} className="chart-row-100">
														<div className="chart-column w-100">
															<SplineAreaChartYahclickNGBandwidth
																data={Bandwidth?.data}
																times={Bandwidth?.times}
																type={yahclickBandwidthNG[0]?.type}
																id={`${yahclickBandwidthNG[0]?.id}`}
																dispatch={dispatch}
																navigate={navigate}
															/>
														</div>
													</div>
												))}
											</div>
										) : (
											<div className="flex h-64 items-center justify-center">
												<p className="text-blue-gray text-xs sm:text-sm">Loading data...</p>
											</div>
										)}
									</div>
								</div>
							</CustomAccordion>
						)}
					</div>
				) : (
					<div className="flex h-64 items-center justify-center">
						<span className="font-normal text-gray-400 text-sm leading-tight">
							No data available
						</span>
					</div>
				)}
			</div>
		</>
	);
};

export default YahsatServices;
